import { IconProp } from '@fortawesome/fontawesome-svg-core';

/**
 * FrostMenuItem interface for menu items
 */
export interface FrostMenuItem {
    id: string;
    label: string;
    description?: string;
    icon?: IconProp;
    iconColor?: string;
    labelColor?: string;
    disabled?: boolean;
    visible?: boolean;
    link?: string;
    linkTarget?: '_blank' | '_self' | '_parent' | '_top';
    badge?: string | number;
    badgeColor?: string;
    action?: (item: FrostMenuItem) => void;
    data?: any;
    executeOnClick?: boolean;
    keepMenuOpen?: boolean;
    children?: (FrostMenuItem | MenuSeparator)[];
    metadata?: Record<string, any>;
    value?: boolean; // Toggle switch value for settings menu items
}

/**
 * MenuSeparator interface for menu separators
 */
export interface MenuSeparator {
    isSeparator: boolean;
    label?: string;
    description?: string;
}

/**
 * Helper function to create a menu separator
 */
export function createMenuSeparator(label?: string, description?: string): MenuSeparator {
    return {
        isSeparator: true,
        label: label || undefined,
        description: description || undefined
    };
}

/**
 * MenuItem type guard
 */
export function isMenuItem(item: FrostMenuItem | MenuSeparator): item is FrostMenuItem {
    return !('isSeparator' in item) || !item.isSeparator;
}

/**
 * MenuSeparator type guard
 */
export function isMenuSeparator(item: FrostMenuItem | MenuSeparator): item is MenuSeparator {
    return 'isSeparator' in item && item.isSeparator === true;
}

/**
 * Menu position type
 */
export type MenuPosition = 'left' | 'right' | 'top' | 'bottom';